export default __webpack_public_path__ + "static/235-04e605fdbace4dfa9b1192d9a48f7b84.gif";